import { motionValue, MotionValue } from "framer-motion";
import type { Card, PileRef } from "@solitaire/game-engine";

/**
 * Modul-globaler Drag-Zustand — kein React-State,
 * um Re-Renders während des Drags zu vermeiden.
 */
export interface DragPayload {
  cards: readonly Card[];
  fromPile: PileRef;
}

let current: DragPayload | null = null;

export const dragState = {
  set(payload: DragPayload): void {
    current = payload;
  },
  get(): DragPayload | null {
    return current;
  },
  clear(): void {
    current = null;
  },
};

/**
 * Geteilte Drag-Position für den aktiven Stapel.
 * Die gezogene Karte schreibt in diese Werte (via framer-motion drag).
 * Follower-Karten lesen sie — ohne Re-Render, direkt via CSS-Transform.
 */
export const sharedDragX: MotionValue<number> = motionValue(0);
export const sharedDragY: MotionValue<number> = motionValue(0);

/**
 * Flip-Animation: cardId → Vorderseiten-URL.
 * Wird von StockPile gesetzt, von FlyAnimationContext konsumiert.
 */
export const pendingFlipFaceUrls = new Map<string, string>();

/** Liest den Drop-Target-Bezeichner aus dem Element unter dem Cursor. */
export function findDropTarget(clientX: number, clientY: number): string | null {
  const elements = document.elementsFromPoint(clientX, clientY);
  for (const el of elements) {
    const target = (el as HTMLElement).dataset?.droptarget;
    if (target) return target;
  }
  return null;
}
